import { render } from "./SceneConstructorMenuItemIcon.vue?vue&type=template&id=f4979112&ts=true"
import script from "./SceneConstructorMenuItemIcon.vue?vue&type=script&lang=ts"
export * from "./SceneConstructorMenuItemIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__